<template>
  <v-card class="elevation-0">
    <v-card-text class="pa-0">
      <div class="combo-container">
        <mf-upload-image
          v-model="offerCombo.image"
          dense
          file-name="oferta_combo"
          :loading="loading"
          :disabled="isDisabledInRules(rules.comboOfferSales.removeImage) || isCampaignWithOfferSale"
          :disabled-remove="!isDisabledInRules(rules.comboOfferSales.removeImage)"
          @upload="saveImage"
        />
        <div>
          <span :class="!disabledFields ? 'combo-container-fields pb-6' : 'combo-container-fields--disabled'" class="pt-3" style="max-width: 530px"
            >O nome que você insere aqui vai ser exibido para o seu consumidor final no seu aplicativo e também nas campanhas da mar.ia.</span
          >
          <div :class="!disabledFields ? 'combo-container-fields' : 'combo-container-fields--disabled'">
            <tooltip :disabled="!isDisabledInRules(rules.comboOfferSales.name)" :message="tooltipMessage">
              <v-text-field
                v-if="!disabledFields"
                v-model="offerCombo.name"
                outlined
                label="Nome do combo"
                counter="120"
                maxlength="120"
                :error="cardValidation && cardValidation.name.$invalid && cardValidation.name.$error"
                :disabled="disabledFields || isDisabledInRules(rules.comboOfferSales.name) || isCampaignWithOfferSale"
                class="field"
              />
              <div v-else class="disabled-fields">
                <span class="title">Nome do combo:</span>
                <span class="value">{{ offerCombo.name }}</span>
              </div>
            </tooltip>
            <tooltip :disabled="!isDisabledInRules(rules.comboOfferSales.maximumPerClient)" :message="tooltipMessage">
              <v-text-field
                v-if="!disabledFields"
                v-model="offerCombo.maximum_per_client"
                type="number"
                outlined
                label="Máximo de combos por cpf"
                :error="cardValidation && cardValidation.maximum_per_client.$invalid && cardValidation.maximum_per_client.$error"
                :disabled="disabledFields || isDisabledInRules(rules.comboOfferSales.maximumPerClient) || isCampaignWithOfferSale"
                class="field"
              />
              <div v-else class="disabled-fields">
                <span class="title">Máximo de combos por CPF:</span>
                <span class="value">{{ offerCombo.maximum_per_client }}</span>
              </div>
            </tooltip>
            <v-text-field
              v-if="!disabledFields && isIntelligentDistributionEnabled && !isIntelligentDistributionEditDisabled"
              v-model="offerCombo.distribution_limit"
              type="number"
              outlined
              placeholder="Sem limite"
              label="Limite de ofertas"
              class="field"
              :error="cardValidation && cardValidation.distribution_limit.$invalid && cardValidation.distribution_limit.$error"
              :disabled="disabledFields || isCampaignWithOfferSale"
              :min="0"
              @keydown="isNumber"
              @input="convertToNumber"
            />
            <div v-else-if="isIntelligentDistributionEnabled" class="disabled-fields">
              <span class="title">Limite de ofertas:</span>
              <span class="value">{{ offerCombo.distribution_limit || 'Sem limite' }}</span>
            </div>
            <div v-if="!isCampaignWithOfferSale" :class="!disabledFields ? 'combo-container-status' : 'combo-container-status--disabled'">
              <span> Status: </span>
              <mf-toggle v-model="offerCombo.active" :label="offerCombo.active ? 'Combo ativo' : 'Combo inativo'" :disabled="disabledFields" />
            </div>
            <div v-else :class="!disabledFields ? 'combo-container-status' : 'combo-container-status--disabled'">
              <span> Oferta visível: </span>
              <mf-toggle v-model="offerCombo.isVisible" :disabled="disabledFields" />
            </div>
            <div v-if="hasComboDiscountByCountModule" :class="!disabledFields ? 'combo-container-status' : 'combo-container-status--disabled'">
              <mf-tooltip right max-width="400">
                <template #activator>
                  <span> Modelo de liberação de desconto: </span>
                  <mf-toggle
                    v-model="offerCombo.discount_by_count"
                    :label="offerCombo.discount_by_count ? 'Desconto baseado em contagem de itens' : 'Desconto baseado em quantidade de itens'"
                    :disabled="disabledFields || isCampaignWithOfferSale"
                  />
                </template>
                <span>
                  Controla a quantidade de desconto aplicado de acordo com a configuração de produtos gatilhos:<br />
                  <strong>Quantidade de itens:</strong> Considera o peso ou volume total dos produtos somados.<br />
                  Exemplo: 3 unidades de 500g cada = 1,5 kg<br />
                  <strong>Contagem de itens:</strong> Considera cada unidade registrada no PDV como uma unidade individual, independente de peso ou volume.<br />
                  Exemplo: 3 unidades de 500g cada = 3 unidades
                </span>
              </mf-tooltip>
            </div>
          </div>
        </div>
        <mf-button
          v-if="!disabledFields && !isCampaignWithOfferSale"
          class="ml-auto"
          size="sm"
          type="icon"
          icon="delete"
          color="cinza-l20"
          :disabled="statusCampaign === 'active' || isIndustryCampaign || automaticCampaign"
          @click="$emit('removeItem', idKey)"
        />
      </div>
      <v-row>
        <v-col class="px-3 pb-0" cols="6">
          <div class="table-title">
            <div class="mb-2 d-flex align-center justify-space-between">
              <h1 class="ma-0">Produto gatilho {{ listAllTrigger().length > 0 ? `(${listAllTrigger().length})` : '' }}</h1>
              <modal-graphql-search-content
                v-if="!isRevision && !isCampaignWithOfferSale"
                :selected-items="offerCombo.trigger_products"
                button-activator
                button-is-flat
                hide-csv-upload
                return-groups
                button-text="Escolher produtos"
                link
                :disabled="automaticCampaign || isIntelligentDistributionEditDisabled"
                :is-segmentation="segments && segments.length > 0 && statusCampaign == 'active'"
                @confirm="insertProducts($event, 'trigger')"
              />
            </div>
            <p class="mb-4">{{ triggerDescriptionText }}</p>
          </div>
        </v-col>
        <v-col class="px-3 pl-0 pb-0" cols="6">
          <div class="table-title">
            <div class="mb-2 d-flex align-center justify-space-between">
              <h1 class="ma-0">Produto com desconto {{ listAllTarget().length > 0 ? `(${listAllTarget().length})` : '' }}</h1>
              <modal-graphql-search-content
                v-if="!isRevision && !isCampaignWithOfferSale"
                :selected-items="offerCombo.target_products"
                button-activator
                button-is-flat
                hide-csv-upload
                :disable-groups="isJaneModulePermission ? false : true"
                :is-length-limited="isJaneModulePermission ? false : true"
                :max-selected-items="1"
                return-groups
                button-text="Escolher produtos"
                link
                :disabled="automaticCampaign || isIntelligentDistributionEditDisabled"
                :is-segmentation="segments && segments.length > 0 && statusCampaign == 'active'"
                @confirm="insertProducts($event, 'target')"
              />
            </div>
            <p class="mb-4">
              {{ discountDescriptionText }}
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0 px-3">
          <mf-info-card icon="info" :vHtml="sameProductInfoContent" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="px-3 pt-0" cols="6">
          <combo-table
            v-if="(ungroupedTriggerProducts.length && groupedTriggerProducts.length) || !groupedTriggerProducts.length"
            :products="ungroupedTriggerProducts"
            :repeated-skus="repeatedSkus"
            :is-disabled-in-rules="isDisabledInRules"
            :is-industry-campaign="isIndustryCampaign"
            :tooltip-message="tooltipMessage"
            :automatic-campaign="automaticCampaign"
            :validations="validations.offerComboArray.$each[idKey].trigger_products"
            :all-products="offerCombo.trigger_products"
            :is-revision="isRevision"
            :is-campaign-with-offer-sale="isCampaignWithOfferSale"
            @remove-item="removeItem($event, '', 'trigger_products')"
          />
          <div v-if="groupedTriggerProducts && groupedTriggerProducts.length > 0">
            <combo-table
              v-for="group in groupedTriggerProducts"
              :key="group._id"
              class="mt-4"
              :products="group.products"
              :group="group"
              :repeated-skus="repeatedSkus"
              :is-disabled-in-rules="isDisabledInRules"
              :is-industry-campaign="isIndustryCampaign"
              :tooltip-message="tooltipMessage"
              :automatic-campaign="automaticCampaign"
              :all-products="offerCombo.trigger_products"
              :validations="validations.offerComboArray.$each[idKey].trigger_products"
              :is-revision="isRevision"
              :is-campaign-with-offer-sale="isCampaignWithOfferSale"
              @remove-group="removeGroup(group._id, 'trigger_products')"
              @remove-item="removeItem($event, group._id, 'trigger_products')"
            />
          </div>
        </v-col>
        <v-col class="px-3 pl-0 pt-0" cols="6">
          <combo-table
            v-if="(ungroupedTargetProducts.length && groupedTargetProducts.length) || !groupedTargetProducts.length"
            :products="ungroupedTargetProducts"
            :repeated-skus="repeatedSkus"
            :is-disabled-in-rules="isDisabledInRules"
            :is-industry-campaign="isIndustryCampaign"
            :tooltip-message="tooltipMessage"
            :automatic-campaign="automaticCampaign"
            variant="target"
            :all-products="offerCombo.target_products"
            :validations="validations.offerComboArray.$each[idKey].target_products"
            :is-revision="isRevision"
            :is-campaign-with-offer-sale="isCampaignWithOfferSale"
            @remove-item="removeItem($event, '', 'target_products')"
          />

          <div v-if="groupedTargetProducts && groupedTargetProducts.length > 0">
            <combo-table
              v-for="group in groupedTargetProducts"
              :key="group._id"
              class="mt-4"
              variant="target"
              :products="group.products"
              :group="group"
              :repeated-skus="repeatedSkus"
              :is-disabled-in-rules="isDisabledInRules"
              :is-industry-campaign="isIndustryCampaign"
              :tooltip-message="tooltipMessage"
              :automatic-campaign="automaticCampaign"
              :all-products="offerCombo.target_products"
              :validations="validations.offerComboArray.$each[idKey].target_products"
              :is-revision="isRevision"
              :is-campaign-with-offer-sale="isCampaignWithOfferSale"
              @remove-group="removeGroup(group._id, 'target_products')"
              @remove-item="removeItem($event, group._id, 'target_products')"
            />
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { rules } from '../../../helpers/rules.js'
import Tooltip from '../Tooltip.vue'
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import findIndex from 'lodash/findIndex'
import ComboTable from './ComboTable.vue'
import { getAllSingleProductsOutsideAndInsideGroup } from '@/modules/campanhas/gestao-ofertas-v2/helpers/products.js'
import intelligentDistributionMixin from '../../mixins/intelligent-distribution'
export default {
  name: 'ProductsOnOfferComboCards',
  components: {
    Tooltip,
    ComboTable,
    ModalGraphqlSearchContent: () => import('@/components/ModalGraphqlSearchContent.vue'),
  },
  mixins: [intelligentDistributionMixin],
  props: {
    campaign: {
      type: Object,
      default: () => ({}),
    },
    automaticCampaign: {
      type: Boolean,
      default: false,
    },
    disabledFields: {
      type: Boolean,
      default: false,
    },
    disableExport: {
      type: Boolean,
      default: false,
    },
    idKey: {
      type: Number,
      required: true,
    },
    discountDescriptionText: {
      type: String,
      default: '',
    },
    triggerDescriptionText: {
      type: String,
      default: '',
    },
    statusCampaign: {
      type: String,
      default: '',
    },
    offerSalesKeyName: {
      type: String,
      default: '',
    },
    secondOfferSalesKeyName: {
      type: String,
      default: '',
    },
    updateEans: {
      type: Function,
      default: () => {},
    },
    offerCombo: {
      type: Object,
      required: true,
    },
    eans: {
      type: Object,
      default: () => {},
    },
    cardValidation: {
      type: Object,
      default: () => {},
    },
    validations: {
      type: Object,
      default: () => {},
    },
    segments: {
      type: Array,
      default: () => [],
    },
    repeatedSkus: {
      type: Array,
      default: () => [],
    },
    isDisabledInRules: {
      type: Function,
      default: () => false,
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isRevision: {
      type: Boolean,
      default: false,
    },
    isCampaignWithOfferSale: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localProducts: [],
    rules,
    loading: false,
  }),
  computed: {
    hasComboDiscountByCountModule() {
      return this.$getAllowedModules()['combo_discount_by_count']
    },
    sameProductInfoContent() {
      return '<span style="color: rgb(0, 77, 153)">Os produtos gatilhos e descontos são avaliados de maneira <b>independente</b> durante a aplicação de desconto. Isso significa que caso seja configurado o mesmo produto ou grupo no gatilho e no desconto, o desconto é liberado considerando apenas a quantidade inserida no produto gatilho. Por exemplo, para criar um combo utilizando o mesmo produto ou grupo no gatilho e no desconto, dando um desconto na <b>segunda</b> unidade, a quantidade no gatilho deve ser <b>2</b>.</span>'
    },
    productsHasLength() {
      return this.offerCombo.target_products.length >= 1
    },

    isJaneModulePermission() {
      return this.$getAllowedModules()['jane']
    },

    headersProductTrigger() {
      const actions = {
        title: '',
        dataIndex: 'action',
        width: '5%',
        scopedSlots: { customRender: 'action' },
      }
      const headers = [
        {
          title: 'SKU',
          dataIndex: 'sku',
          width: '15%',
          scopedSlots: { customRender: 'sku' },
        },
        {
          title: 'EAN',
          dataIndex: 'ean',
          width: '15%',
          scopedSlots: { customRender: 'ean' },
        },
        {
          title: 'Nome',
          dataIndex: 'name',
          width: '45%',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: 'Quant.',
          dataIndex: 'quantity',
          width: '15%',
          scopedSlots: { customRender: 'quantity' },
        },
      ]

      if (!this.disabledFields) {
        headers.push(actions)
      }

      return headers
    },
    headersProductDiscount() {
      const actions = {
        title: '',
        dataIndex: 'action',
        width: '5%',
        scopedSlots: { customRender: 'action' },
      }
      const headers = [
        {
          title: 'SKU',
          dataIndex: 'sku',
          width: '15%',
          scopedSlots: { customRender: 'sku' },
        },
        {
          title: 'EAN',
          dataIndex: 'ean',
          width: '15%',
          scopedSlots: { customRender: 'ean' },
        },
        {
          title: 'Nome',
          dataIndex: 'name',
          width: '45%',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: 'Desconto',
          dataIndex: 'percentage_discount',
          width: '15%',
          scopedSlots: { customRender: 'percentage_discount' },
        },
      ]

      if (!this.disabledFields) {
        headers.push(actions)
      }

      return headers
    },
    extraFieldsDiscount() {
      return !this.disabledFields ? { percentage_discount: 0 } : {}
    },
    extraFieldsTrigger() {
      return !this.disabledFields ? { quantity: 0 } : {}
    },
    ungroupedTriggerProducts() {
      return this.offerCombo.trigger_products.filter((product) => !product.isGroup)
    },
    groupedTriggerProducts() {
      return this.offerCombo.trigger_products.filter((product) => product.isGroup)
    },
    ungroupedTargetProducts() {
      return this.offerCombo.target_products.filter((product) => !product.isGroup)
    },
    groupedTargetProducts() {
      return this.offerCombo.target_products.filter((product) => product.isGroup)
    },
    isIntelligentDistributionEditDisabled() {
      return this.isIntelligentDistributionEnabled && ['active', 'scheduled'].includes(this.campaign.status)
    },
  },
  methods: {
    listAllTrigger() {
      return getAllSingleProductsOutsideAndInsideGroup(this.offerCombo.trigger_products)
    },
    listAllTarget() {
      return getAllSingleProductsOutsideAndInsideGroup(this.offerCombo.target_products)
    },
    getEans(value) {
      this.eans = value
    },
    removeImage() {
      this.offerCombo.image = ''
    },
    saveImage({ base64, filename }) {
      this.loading = true
      this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: { base64, filename },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.offerCombo.image = url
          this.loading = false
        })
        .catch(() => this.$snackbar({ message: 'Erro ao subir imagem.', snackbarColor: 'error' }))
    },
    insertProducts(groupProducts, type) {
      let clonedProducts = []
      groupProducts.forEach((product, index) => {
        const productIndex = findIndex(this.products, (clonedProduct) => {
          return (clonedProduct._id && clonedProduct._id === product._id) || (clonedProduct.sku && clonedProduct.sku === product.sku)
        })
        if (productIndex >= 0) {
          let newProduct = {}
          if (product.products) {
            const { products, imported, ...groupWithoutProducts } = this.products[productIndex]
            newProduct = Object.assign(this.formatProduct(product, index, imported), groupWithoutProducts)
          } else {
            const isImported = false
            newProduct = Object.assign(this.formatProduct(product, index, isImported), this.products[productIndex])
          }

          clonedProducts.push(newProduct)
        } else {
          let isImported
          if (this.offerSalesKeyName !== 'combo_offer_sales') {
            isImported = true
            clonedProducts.push(this.formatProduct(product, index, isImported))
          } else {
            isImported = false
            clonedProducts.push(Object.assign(this.formatProduct(product, index, isImported), { quantity: product.quantity || 0 }))
          }
        }
      })
      if (type === 'trigger') {
        this.offerCombo.trigger_products = [...this.mergeProducts(this.offerCombo.trigger_products, clonedProducts, 'trigger')]
      } else {
        this.offerCombo.target_products = [...this.mergeProducts(this.offerCombo.target_products, clonedProducts, 'target')]
      }
    },
    mergeProducts(products, clonedProducts, variant) {
      clonedProducts.forEach((clonedProduct, index) => {
        if (products[index]) {
          if (variant === 'trigger') clonedProduct.quantity = products[index].quantity
          else clonedProduct.percentage_discount = products[index].percentage_discount
        }
      })

      return clonedProducts
    },
    formatProduct(product, index, isImported) {
      let newProduct = {}
      if (product.target_products && product.trigger_products) return product
      if (product.products) {
        const formattedProducts = product.products.map((item) => {
          return {
            isGroup: true,
            imported: isImported,
            disabled: this.isDisabledProduct(isImported),
            active: typeof item.active === 'boolean' ? item.active : true,
            sku: item.sku,
            ean: item.ean,
            _id: item._id,
            eans: item.eans.length === 1 ? [item.ean] : item.eans,
            name: item.name,
            origin: 'search',
            original_eans: item.product?.eans ? item.product.eans : [],
            product: item.product
              ? item.product
              : {
                  ean: item.ean,
                  eans: item.eans.length > 1 ? item.eans : [item.ean],
                },
            index,
          }
        })
        newProduct = Object.assign({
          _id: product._id,
          isGroup: true,
          imported: isImported,
          disabled: this.isDisabledProduct(isImported),
          name: product.name,
          products: formattedProducts,
          index,
          percentage_discount: 0,
          quantity: 0,
        })
      } else {
        newProduct = Object.assign({
          _id: product._id,
          imported: isImported,
          disabled: this.isDisabledProduct(isImported),
          active: typeof product.active === 'boolean' ? product.active : true,
          sku: product.sku,
          ean: product.ean,
          eans: product?.eans?.length === 1 ? [product.ean] : product.eans,
          name: product.name,
          product: {
            ean: product.ean,
            eans: product.eans.length > 1 ? product.eans : [product.ean],
          },
          index,
          percentage_discount: 0,
          quantity: 0,
        })
      }
      return newProduct
    },
    isDisabledProduct(isImported) {
      return (
        this.automaticCampaign ||
        this.statusCampaign === 'finished' ||
        this.statusCampaign === 'expired' ||
        this.statusCampaign === 'industry_rejected' ||
        ((this.statusCampaign === 'active' || this.statusCampaign === 'scheduled') && isImported !== true)
      )
    },
    removeItem(item, groupId, key) {
      if (groupId) {
        const newOfferSales = this.offerCombo[key].map((offer) => {
          if (offer._id === groupId) {
            return {
              ...offer,
              products: offer.products
                .map((product) => {
                  if (product.sku !== item.sku) return product
                })
                .filter((item) => item),
            }
          }
          return offer
        })
        this.offerCombo[key] = newOfferSales
      } else {
        const newOfferSales = this.offerCombo[key]
          .map((offer) => {
            if (offer.sku !== item.sku) return offer
          })
          .filter((item) => item)
        this.offerCombo[key] = newOfferSales
      }
    },
    removeGroup(groupId, key) {
      const newOfferSales = this.offerCombo[key]
        .map((offer) => {
          if (offer._id !== groupId) return offer
        })
        .filter((item) => item)
      this.offerCombo[key] = newOfferSales
    },
    isNumber(evt) {
      const key = evt.key
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End']

      const isDigit = /^[0-9]$/.test(key)
      const isAllowedKey = allowedKeys.includes(key)
      const isCtrlC = evt.ctrlKey && key === 'c'
      const isCtrlV = evt.ctrlKey && key === 'v'
      const isCtrlA = evt.ctrlKey && key === 'a'

      if (!isDigit && !isAllowedKey && !isCtrlC && !isCtrlV && !isCtrlA) {
        evt.preventDefault()
      }
    },
    convertToNumber(value) {
      const cleanValue = value.replace(/[^0-9]/g, '')
      const numericValue = cleanValue === '' ? null : parseInt(cleanValue, 10)
      this.offerCombo.distribution_limit = numericValue
    },
  },
}
</script>

<style lang="scss" scoped>
.combo-container {
  display: flex;
  padding-top: 32px;
  &-img {
    display: flex;
    width: 160px;
    height: 160px;
    margin-left: 24px;
    border: 2px solid $cinza-l90;
    box-sizing: border-box;
    &-remove {
      position: absolute;
      right: 0;
    }
    &-not {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      row-gap: 10px;
      width: 160px;
      height: 100%;
      background: $cinza-l90;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: $cinza-0;
    }
  }
  &-fields {
    display: flex;
    align-items: center;
    padding-left: 48px;
    column-gap: 40px;
    .field {
      width: 192px;
    }

    &--disabled {
      @extend .combo-container-fields;
      column-gap: 48px;
      .disabled-fields {
        display: flex;
        flex-direction: column;
        .title {
          font-family: 'Lato' !important;
          font-weight: 400;
          font-size: 18px !important;
          line-height: 22px;
          color: $cinza-d10;
        }
        .value {
          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          letter-spacing: 0.4px;
          color: $cinza-0;
          padding-top: 4px;
        }
      }
    }
  }
  &-delete {
    position: absolute;
    top: 16px;
    right: 8px;
  }
  &-status {
    font-weight: 400;
    font-size: 18px;
    color: $cinza-d10;
    padding-bottom: 8px;
    &--disabled {
      @extend .combo-container-status;
      padding-bottom: 0;
      padding-top: 25px;
      ::v-deep .v-input--selection-controls {
        padding-top: 4px !important;
      }
    }
    ::v-deep .v-input--selection-controls {
      margin: 0;
      padding-top: 8px;
      padding-left: 4px;
    }
  }
}

.table-title {
  h1 {
    font-size: 18px;
    color: $cinza-d10;
    font-weight: 700;
  }
  p {
    font-size: 14px;
    color: $cinza-0;
    font-weight: 400;
  }
}
</style>
